import { entityStatuses } from './entityStatusConfig';

export const customerStatuses = entityStatuses;

export const customerFormInitialValues = {
  companyName: '',
  contactNumber: '',
  branchLocations: {
    branches: [],
    primaryBranchLocation: '',
  },
  photoUrl: '',
  status: 'Active',
};
